import * as Yup from 'yup';

const maintenanceSchema = Yup.object({
  external_id: Yup.mixed()
    .label('Maestro ID')
    .nullable(),
  external_url: Yup.string()
    .label('Maestro-linkki')
    .nullable(),
  external_error: Yup.string()
    .label('Maestro-virheviesti')
    .nullable(),
  maintenance_status_id: Yup.string().label('Tila'),
  location_id: Yup.number().label('Toimipiste'),
  kilometer_gauge_at: Yup.number()
    .label('Kilometrimittarin lukema')
    .nullable(),
  kilometer_increment: Yup.number()
    .label('Ajettu edellisen huollon jälkeen')
    .nullable()
});

export default maintenanceSchema;
export type MaintenanceSchema = ReturnType<typeof maintenanceSchema.cast>;
